import type { FunctionComponent } from 'react';

export const ReportSkillIcon: FunctionComponent = () => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg fill="none" height="16" viewBox="0 0 17 16" width="17" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.49992 5.83334V8.50001M8.49992 10.3333V10.3267M8.66659 10.3333C8.66659 10.4254 8.59197 10.5 8.49992 10.5C8.40787 10.5 8.33325 10.4254 8.33325 10.3333C8.33325 10.2413 8.40787 10.1667 8.49992 10.1667C8.59197 10.1667 8.66659 10.2413 8.66659 10.3333Z"
            stroke="#6E6E6C"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M2.36462 10.8186L7.35394 2.42744C7.87076 1.55824 9.12921 1.55824 9.64603 2.42744L14.6353 10.8186C15.1638 11.7073 14.5233 12.8333 13.4893 12.8333H3.51067C2.47665 12.8333 1.83616 11.7073 2.36462 10.8186Z"
            stroke="#6E6E6C"
            strokeLinecap="square"
            strokeWidth="1.5"
        />
    </svg>
);
